
















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
// components
import TemplateSettings from "@/components/templates/TemplatesSettings.vue";
import TemplateBackground from "@/components/templates/TemplateBackground.vue";
import TemplateContent from "@/components/templates/TemplateContent.vue";
import TemplateButtons from "@/components/templates/TemplateButtons.vue";
import TemplatePreviewModal from "@/components/templates/modals/TemplatePreviewModal.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import TemplateInfoModal from "@/components/templates/modals/TemplateInfoModal.vue";
// service methods
import { createTemplate, getTemplate, updateTemplate } from "@/services/templates/templateService";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";
// types
import i18n from "@/i18n";
import { Button, Content, ContentDto, ContentType, Settings, Template, TemplateBg, TemplateTypeEnum } from "@/services/templates/types";
import { FormComponent, FormComponentModel } from "@/services/autoSettings/types";
import { Guid } from "guid-typescript";
// validation
import { validateForm } from "@/services/validation/validationService";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import { bus } from "@/bus";

@Component<TemplateForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        "template-info-modal": TemplateInfoModal,
        TemplateContent,
        TemplateButtons,
        TemplateBackground,
        TemplateSettings,
        TemplatePreviewModal,
        HeaderActionButtons,
        UnsavedFormModal
    }
})
export default class TemplateForm extends Vue {
    @Prop() private templateId!: string;
    @Prop() private folderId!: string;
    // local state
    template = {
        folderId: this.folderId ? this.folderId : "",
        type: TemplateTypeEnum.informationScreen,
        name: "",
        width: 0,
        height: 0,
        background: { backgroundId: "", backgroundName: "" } as TemplateBg,
        content: [] as ContentDto[],
        buttons: [] as Button[]
    } as Template;

    // used for comparing if form have changes
    priorTemplateState = JSON.parse(JSON.stringify(this.template)) as Template;
    formState = false;
    background = {} as TemplateBg;
    content = [] as Content[];
    buttons = [] as Button[];
    componentsData = [] as FormComponentModel[];
    nextRoute = "";
    saveClicked = false;
    continue = false;
    routeParams = {};
    localId = this.templateId || "";

    // lifecycle hooks
    created() {
        this.fetchData();
        this.initComponents();
    }

    // computed
    get settings(): Settings {
        return {
            height: this.template.height,
            name: this.template.name,
            width: this.template.width
        } as Settings;
    }

    get currentBackground(): TemplateBg {
        return this.template.background ? this.template.background : {} as TemplateBg;
    }

    get currentContent(): Content[] {
        if (!this.template.content) return [] as Content[];

        const contentArray = [] as Content[];
        this.template.content.forEach(x => {
            const content = {} as Content;

            content.contentId = (x.channelGroupId || x.channelId || x.stageId) as string;
            content.id = x.id ? x.id : Guid.create().toString();
            content.layer = x.layer;
            content.x = x.x;
            content.y = x.y;
            content.name = x.name;
            if (x.channelGroupId) {
                content.type = ContentType.ChannelGroup;
            } else if (x.channelId) {
                content.type = ContentType.Channel;
            } else {
                content.type = ContentType.Stage;
            }
            content.typeName =
                i18n.t(`background.contentTypes.${ContentType[content.type].toLowerCase()}`).toString();
            content.status = x.status;

            contentArray.push(content);
        });
        return contentArray;
    }

    get components(): FormComponentModel[] {
        return this.componentsData.sort((x, y) => x.order - y.order);
    }

    get componentsAutoSettingKey(): string {
        let settingsKey = "templateFormComponents";
        settingsKey += this.localId ? "-edit" : "-create";
        return settingsKey;
    }

    // methods
    // async initComponents() {
    //     let components = getSetting(this.componentsAutoSettingKey);
    //     if (!components) {
    //         await setSetting(this.componentsAutoSettingKey,
    //             [
    //                 {
    //                     componentName: "TemplateSettings",
    //                     sectionName: i18n.t("common.settings"),
    //                     order: 0,
    //                     collapseState: true
    //                 },
    //                 {
    //                     componentName: "TemplateBackground",
    //                     sectionName: i18n.t("template.background"),
    //                     order: 1,
    //                     collapseState: true
    //                 },
    //                 {
    //                     componentName: "TemplateContent",
    //                     sectionName: i18n.t("template.channelAndChannelGroups"),
    //                     order: 2,
    //                     collapseState: true
    //                 },
    //                 {
    //                     componentName: "TemplateButtons",
    //                     sectionName: i18n.t("template.buttons"),
    //                     order: 3,
    //                     collapseState: true
    //                 }]);
    //         components = getSetting(this.componentsAutoSettingKey);
    //     }
    //
    //     components = !components
    //         ? await this.initAutoSettings(defaultComponents)
    //         : await this.updateComponents(defaultComponents, autoSettingComponents);
    //
    //     this.componentsData = components.map((x: FormComponent) => ({
    //         componentName: x.componentName,
    //         order: x.order,
    //         active: false,
    //         activeDropTarget: false,
    //         collapseState: x.collapseState,
    //         sectionName: x.sectionName
    //     }));
    // }

    async initComponents() {
        let autoSettingComponents = getSetting(this.componentsAutoSettingKey) as FormComponent[];
        const defaultComponents = [
            {
                componentName: "TemplateSettings",
                // sectionName is obsolete for template form
                sectionName: i18n.t("common.settings"),
                order: 0,
                collapseState: true
            },
            {
                componentName: "TemplateBackground",
                // sectionName is obsolete for template form
                sectionName: i18n.t("template.background"),
                order: 1,
                collapseState: true
            },
            {
                componentName: "TemplateContent",
                // sectionName is obsolete for template form
                sectionName: i18n.t("template.channelAndChannelGroups"),
                order: 2,
                collapseState: true
            },
            {
                componentName: "TemplateButtons",
                // sectionName is obsolete for template form
                sectionName: i18n.t("template.buttons"),
                order: 3,
                collapseState: true
            }] as FormComponent[];

        autoSettingComponents = !autoSettingComponents
            ? await this.initAutoSettings(defaultComponents)
            : await this.updateComponents(defaultComponents, autoSettingComponents);

        this.componentsData = autoSettingComponents.map((x: FormComponent) => ({
            componentName: x.componentName,
            order: x.order,
            active: false,
            activeDropTarget: false,
            collapseState: x.collapseState,
            sectionName: x.sectionName
        }));
    }

    async initAutoSettings(defaultComponents: FormComponent[]) {
        await setSetting(this.componentsAutoSettingKey,
            defaultComponents);
        return getSetting(this.componentsAutoSettingKey);
    }

    async updateComponents(defaultComponents: FormComponent[], components: FormComponent[]) {
        const componentsToBeAdded = defaultComponents
            .filter(x => !components.map(x => x.componentName).includes(x.componentName));
        const componentsToBeRemoved = components
            .filter(x => !defaultComponents
                .map(x => x.componentName).includes(x.componentName));
        if (componentsToBeAdded.length > 0) {
            components = components.concat(componentsToBeAdded);
        }
        if (componentsToBeRemoved.length > 0) {
            componentsToBeRemoved.forEach(cr => {
                components = components.filter(x => x.componentName !== cr.componentName);
            });
        }

        if (componentsToBeAdded.length > 0 || componentsToBeRemoved.length > 0) {
            components.sort((a, b) => a.order - b.order)
                .forEach((el, index) => {
                    el.order = index;
                });
            await setSetting(this.componentsAutoSettingKey,
                components);
        }

        return components;
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            this.retrieveData();
            this.setTemplateDto();

            // we remap and sort the arrays because the order is messed up during the reassignment of the data
            const templateCopy = JSON.parse(JSON.stringify(this.template)) as Template;
            templateCopy.content.sort((a: ContentDto, b: ContentDto) => { return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0; });
            templateCopy.buttons.sort((a: Button, b: Button) => { return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0; });

            const priorTemplateStateCopy = JSON.parse(JSON.stringify(this.priorTemplateState)) as Template;
            priorTemplateStateCopy.content.sort((a: ContentDto, b: ContentDto) => { return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0; });
            priorTemplateStateCopy.buttons.sort((a: Button, b: Button) => { return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0; });

            const noChanges = this.lodash.isEqual(priorTemplateStateCopy, templateCopy);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams, query: { folder: this.template.folderId } });
        this.nextRoute = "";
    }

    async save(back: boolean) {
        this.saveClicked = true;
        await this.childComponentsHandler();
        await this.vscValidate();
        if (!this.formState) {
            this.saveClicked = false;
            return;
        }
        this.setTemplateDto();
        if (!this.localId) {
            createTemplate(this.template).then(id => {
                if (back) this.$router.push({ path: `/templates?folder=${this.template.folderId}` });
                else {
                    this.localId = id;
                    this.template.id = id;
                    this.priorTemplateState = JSON.parse(JSON.stringify(this.template)) as Template;
                    this.saveClicked = false;
                }
            });
            return;
        }

        updateTemplate(this.template).then(response => {
            this.priorTemplateState = JSON.parse(JSON.stringify(this.template)) as Template;
            if (back) this.$router.push({ path: `/templates?folder=${this.template.folderId}` });
            this.saveClicked = false;
        });
    }

    setTemplateDto() {
        this.template.background = this.background && this.background;

        this.template.buttons = this.buttons && this.buttons;

        this.template.content = this.content && this.content.map(x => ({
            id: x.id,
            channelId: x.type === ContentType.Channel ? x.contentId : null,
            channelGroupId: x.type === ContentType.ChannelGroup ? x.contentId : null,
            stageId: x.type === ContentType.Stage ? x.contentId : null,
            x: x.x ? parseInt(x.x.toString()) : x.x,
            y: x.y ? parseInt(x.y.toString()) : x.y,
            layer: x.layer ? parseInt(x.layer.toString()) : x.layer,
            name: x.name,
            status: x.status
        })) as ContentDto[];
    }

    previewTemplate() {
        (this.$refs.templatePreviewModal as any).open(this.localId, this.template.name);
    }

    validators = [] as any[];
    async childComponentsHandler() {
        const components = this.$refs.childComponent as any[];
        components.forEach(component => {
            this.validators.push(component.validators);
            component.emitData();
        });
    }

    retrieveData() {
        const components = this.$refs.childComponent as any[];
        components.forEach(component => {
            component.emitData();
        });
    }

    async vscValidate() {
        this.formState = await validateForm(this.validators);
        if (this.background.backgroundId === "") this.formState = false;
    }

    fetchData() {
        if (this.localId) {
            getTemplate(this.localId)
                .then(response => {
                    this.template = response;
                    bus.$emit("documentTitle", this.template.name);
                    this.priorTemplateState = JSON.parse(JSON.stringify(this.template)) as Template;
                });
        }
    }

    // events && callbacks
    onSettingsUpdated(settings: string) {
        const settingsData = JSON.parse(settings);
        this.template.name = settingsData.name || "";
        this.template.width = parseInt(settingsData.width ? settingsData.width.toString() : 0);
        this.template.height = parseInt(settingsData.height ? settingsData.height.toString() : 0);
    }

    onBackgroundUpdated(background: TemplateBg) {
        this.background = background;
    }

    onContentUpdated(content: Content[]) {
        this.content = content;
    }

    onButtonsUpdated(buttons: Button[]) {
        this.buttons = buttons;
    }

    templateInfo(templateId: string) {
        (this.$refs.templateInfoModal as any).open(templateId);
    }

    onComponentStateChanged(componentState: any) {
        const component = this.componentsData.find(x => x.componentName === componentState.name);
        if (!component) return;

        component.collapseState = componentState.state;
        setSetting(this.componentsAutoSettingKey,
            this.componentsData.map(x => (
                {
                    componentName: x.componentName,
                    order: x.order,
                    collapseState: x.collapseState,
                    sectionName: x.sectionName
                } as FormComponent)));
    }

    // drag & drop event handlers
    drag(event: any) {
        const component = this.componentsData.find(x => x.componentName === event.target.id);
        if (!component) { return; }

        event.dataTransfer.setDragImage((this.$refs[component.componentName] as any)[0], 1000, 0);
        event.dataTransfer.setData(
            "id",
            event.target.id
        );

        component.active = true;
    }

    dragLeave(event: any) {
        const component = this.componentsData.find(x => x.componentName === event.currentTarget.id);
        if (!component) return;
        component.activeDropTarget = false;
    }

    dragOver(event: any) {
        event.preventDefault();
        const component = this.componentsData.find(x => x.componentName === event.currentTarget.id);
        if (!component) return;
        if (component.active) return;
        component.activeDropTarget = true;
    }

    dragEnd() {
        this.componentsData.forEach(x => {
            x.activeDropTarget = false;
            x.active = false;
        });
    }

    swapComponents(event: any) {
        event.preventDefault();
        if (!event.currentTarget) {
            return;
        }

        const target = this
            .componentsData
            .find(x => event.currentTarget && x.componentName === event.currentTarget.id);
        const source = this
            .componentsData
            .find(x => event.dataTransfer && x.componentName === event.dataTransfer.getData("id"));

        if (!(source && target)) { return; }

        const sourceOrder = source.order;
        source.order = target.order;
        target.order = sourceOrder;

        setSetting(this.componentsAutoSettingKey,
            this.componentsData.map(x => ({
                componentName: x.componentName,
                order: x.order,
                collapseState: x.collapseState,
                sectionName: x.sectionName
            } as FormComponent)));
    }

    back() {
        window.history.go(-1);
    }
}
